<mat-toolbar class="content-header">
    <h1 class="page-title">
        <mat-icon fontIcon="cloud_download"></mat-icon>
        {{ "settings.database.download_database" | translate }}
    </h1>

    <span class="toolbar-spacer"></span>
</mat-toolbar>

<div class="panel">
    <div class="database_row">
        <app-range-picker [startDate]="startDate" [endDate]="endDate" (change)="onPickerChanged($event)">
        </app-range-picker>
    </div>

    <div class="database_row">
        <mat-form-field appearance="outline" size="small" class="filter" subscriptSizing="dynamic">
            <mat-label>
                {{ "settings.database.collection" | translate }}
            </mat-label>

            <mat-select [(ngModel)]="currentCollection">
                <mat-select-trigger class="trigger-content">
                    <mat-icon fontIcon="{{
                        currentCollection === 'tracks' ? 'my_location' :
                        currentCollection === 'attachments' ? 'image' :
                        currentCollection === 'events' ? 'event_note' :
                        currentCollection === 'metrics' ? 'bar_chart' : ''}}">
                    </mat-icon>

                    {{ currentCollection | titlecase }}
                </mat-select-trigger>

                <mat-option value="tracks">
                    <mat-icon fontIcon="my_location"></mat-icon>
                    Tracks
                </mat-option>
                <mat-option value="attachments">
                    <mat-icon fontIcon="image"></mat-icon>
                    Attachments
                </mat-option>
                <mat-option value="events">
                    <mat-icon fontIcon="event_note"></mat-icon>
                    Events
                </mat-option>
                <mat-option value="metrics">
                    <mat-icon fontIcon="bar_chart"></mat-icon>
                    Metrics
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" size="small" class="filter" subscriptSizing="dynamic">
            <mat-label>
                {{ "settings.database.export_format" | translate }}
            </mat-label>

            <mat-select [(ngModel)]="exportFormat">
                <mat-select-trigger class="trigger-content">
                    <mat-icon
                        fontIcon="{{ exportFormat === 'json' ? 'code' : exportFormat === 'csv' ? 'table_chart' : '' }}"></mat-icon>
                    {{ exportFormat.toUpperCase() }}
                </mat-select-trigger>

                <mat-option value="json">
                    <mat-icon fontIcon="code"></mat-icon>
                    JSON
                </mat-option>

                <mat-option value="csv">
                    <mat-icon fontIcon="table_chart"></mat-icon>
                    CSV
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div class="submit-btn">
        <lib-button [text]="'settings.database.export' | translate" (click)="exportData()"
            [disabled]="!startDate || !endDate" [loading]="progressBufferValue > 0 && progressBufferValue < 100"
            icon="download">
        </lib-button>
    </div>
</div>

<br />

<div class="progress-container" *ngIf="progressText">
    <div class="progress-content">
        <mat-icon *ngIf="!progressText.startsWith('ERROR:')" class="progress-icon" fontIcon="cloud_download">
        </mat-icon>

        <mat-icon *ngIf="progressText.startsWith('ERROR:')" class="progress-icon error" fontIcon="error_outline">
        </mat-icon>

        <span class="progress-text">{{ progressText }}</span>

        <lib-button color="none" textColor="muted" icon="close" (click)="progressText = ''"
            *ngIf="progressText.startsWith('ERROR:') || progressBufferValue == 100">
        </lib-button>
    </div>

    <div style="display: flex; align-items: center; width: 90%;">
        <mat-progress-bar *ngIf="!progressText.startsWith('ERROR:')" class="custom-progress-bar" [color]="progressColor"
            [mode]="progressMode" [value]="progressValue" [bufferValue]="progressBufferValue">
        </mat-progress-bar>

        <span *ngIf="!progressText.startsWith('ERROR:')" class="progress-percent"
            style="margin-left: 12px; color: var(--primary-color); font-weight: bold;">
            {{ progressValue | number: '1.0-0' }}%
        </span>
    </div>
</div>